import { Icon, IconProps } from '@tabler/icons-react';
import classNames from 'classnames';
import './NSIcon.scss';

// Sizes mirror the FontAwesome SizeProp strings the codebase used, so call
// sites that previously passed size="sm" / "lg" / "2x" keep working. Values are
// pixel sizes approximating FontAwesome's em-based scale on a 16px base.
export type NSIconSize = string | number;

const FA_SIZE_TO_PX: Record<string, number> = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
    '1x': 16,
    '2x': 32,
    '3x': 48,
    '4x': 64,
    '5x': 80,
};

const DEFAULT_SIZE_PX = 16;

export interface INSIconProps extends Omit<IconProps, 'size'> {
    /** Tabler icon component, e.g. IconTrash. Passed as a value like FontAwesome's `icon`. */
    icon: Icon;
    size?: NSIconSize;
    /** Spins the icon (replaces FontAwesome's `spin` prop) via CSS animation. */
    spin?: boolean;
}

const resolveSize = (size: NSIconSize | undefined): NSIconSize => {
    if (size == null) {
        return DEFAULT_SIZE_PX;
    }
    if (typeof size === 'string' && size in FA_SIZE_TO_PX) {
        return FA_SIZE_TO_PX[size];
    }
    return size;
};

const NSIcon = ({
    icon: IconComponent, size, spin = false, className, ...rest
}: INSIconProps) => (
    <IconComponent
        role="img"
        aria-hidden="true"
        size={resolveSize(size)}
        className={classNames('NSIcon', { 'NSIcon--spin': spin }, className)}
        {...rest}
    />
);

export default NSIcon;
